import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_private/vbuyer/quotations/$quotationId/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      params,
      replace: true,
      to: "/vbuyer/quotations/$quotationId/details",
    });
  },
});
